import React from 'react';
import { Navigation } from '../components/Navigation';
import { WhyLaundromatSection } from '../components/WhyLaundromatSection';
import { AboutSection } from '../components/AboutSection';
import { Footer } from '../components/Footer';
export function AboutPage() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-290">
      <Navigation data-id="element-291" />
      <main className="pt-20" data-id="element-292">
        <section className="py-16 sm:py-20 lg:py-24 bg-[#0f2424]" data-id="element-293">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-294">
            <h2 className="text-[#4fd1c5] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-6 sm:mb-8" data-id="element-295">
              Our Mission
            </h2>
            <p className="text-2xl sm:text-3xl md:text-4xl text-white leading-relaxed font-light" data-id="element-296">
              We're creating a platform that brings consistent quality, upgraded
              customer experience, and operational excellence to an industry
              that's historically been fragmented and slow to modernize.
            </p>
          </div>
        </section>

        <WhyLaundromatSection data-id="element-297" />
        <AboutSection data-id="element-298" />
      </main>
      <Footer data-id="element-299" />
    </div>;
}